var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"h-54 px-2 flex items-center bg-bd"},[_c('div',[_c('img',{staticClass:"w-50 h-50",attrs:{"src":require("../assets/logo.jpg"),"alt":""}})]),_c('div',{staticClass:"w-[100%] text-center text-34 font-medium text-primary"},[_vm._v(" 南邓字花 ")])])])
}]

export { render, staticRenderFns }